import type { FaireProductEntity } from "../../entity_types/product";

export const p_5gaaq2gmut: FaireProductEntity = {
  token: "p_5gaaq2gmut",
  type: "product",
  name: "FLAMBEAU FIYA Caribbean Creole",
  brandToken: "b_voryasl0ya",
  brandName: "Bayou Gotham Hot Sauce",
  imageUrl:
    "https://cdn.faire.com/fastly/82a238a046ed7ade237a2d07248adb9fc2916a8470767167629a181d6cb20ed0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28a84aea53f780a3bd9e243c5ffd521ebda4c25facec3a24bc463e31d15da2fb.png",
    "https://cdn.faire.com/fastly/d547ead69860fedbe7c58455cf102cf8375c486f332fa0f4610b0358c2b56cb5.png",
    "https://cdn.faire.com/fastly/8363ff1d518a4711deaea9a6414d9e7a52e1c221e968c6ebe2c7414b0b30e035.jpeg",
    "https://cdn.faire.com/fastly/a1e00857512d17d45eb608804b012afaffcecd1a0e955ef9ed0caa808ac46566.jpeg",
    "https://cdn.faire.com/fastly/baf17e8cc7e69a2dea67b5de92ee33a78e6ce80b766ecef82b0a6aa70a4333f7.png",
  ],
  priceDollars: 6,
  description:
    "FLAMBEAU FIYA ™ is a sweet-heat Caribbean-style hot sauce celebrating the “flambeaux carriers” — one of the oldest traditions of Carnival in New Orleans. Exquisite with pork and rice dishes, seafood, chicken, salads — it’s a fiery balancing act of scotch bonnet and cayenne peppers paired with exotic island 'flare'.\n\nNew Orleans is often considered the Caribbean’s northern-most city, and its evolution of Mardi Gras owes much to its tropic influences. \n\nSpice up the night and liven your libations ‘cause anything goes when it’s Carnival Time and everybody’s having fun!\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:12.617Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
